import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SummaryPaneAlerts from '../SummaryPaneAlerts/SummaryPaneAlerts';
import Drawer from '../../Drawer/Drawer';
import { DynamicObjectInterface } from '../../../../sdk/type';
import { AlertsDrawerProps } from './types/propTypes';
import styles from './AlertsDrawer.module.scss';

export const AlertsDrawer: React.FC<AlertsDrawerProps> = ({ header = '', alerts, onClose, includeBackdrop = true, customBackdrop, direction }) => {
  const { t } = useTranslation();
  
  let date = "";

  const getDisplayDate = (formattedDate : DynamicObjectInterface) => {
    const [day, month, year] = formattedDate.split('/').map(Number);
    const alertDate = new Date(year, month - 1, day);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (
      alertDate.getDate() === today.getDate() &&
      alertDate.getMonth() === today.getMonth() &&
      alertDate.getFullYear() === today.getFullYear()
    ) {
      return t('dashboard.notification.label.today');
    } else if (
      alertDate.getDate() === yesterday.getDate() &&
      alertDate.getMonth() === yesterday.getMonth() &&
      alertDate.getFullYear() === yesterday.getFullYear()
    ) {
      return t('dashboard.notification.label.yesterday');
    } else {
      return formattedDate;
    }
  };

  const children = (
    <>
    <div className={styles['alerts-container']}>
      {alerts.length === 0 ? <div className={styles['empty-title']}> <span className={styles['line']}></span>
          {t('dashboard.notification.label.allUpToDate')}
          <span className={styles['line']}></span></div> : <>{alerts.map((item, index) => {
        let showDate = false;
        const formattedDate = item.formattedDate ?? "";
        if (date !== formattedDate) {
          date = formattedDate;
          showDate = true;
        }
        return (
          <React.Fragment key={item.alertType + index.toString()}>
            {showDate && 
            <p className={styles['date-container']}>{getDisplayDate(formattedDate)}
              <hr hr-line className={styles['hr-line']}></hr>
            </p>}
            <SummaryPaneAlerts
              content={item.content}
              alertType={item.alertType}
              textLinkStyle={item.textLinkStyle}
            />
          </React.Fragment>
        );
      })}</>}
    
    </div>
    </>
  );
  return (
    <div data-testid="drawer-container">
      <Drawer header={<div>{header}</div>} closeIcon={true} closeOnBackdropClick={true} onClose={onClose} bottomGap={0} includeBackdrop={includeBackdrop} customBackdrop={customBackdrop} direction={direction}> 
        {children}
      </Drawer>
    </div>
  );
};

export default AlertsDrawer;
export type { AlertsDrawerProps };
